module.exports = __webpack_public_path__ + "img/iphone1.1cef15ce.png";